import React from 'react'

const Footer = () => {
  return (
    <footer className="footer">
        <div className="footer__content group">
            <div className="container">
                <div className="footer__left">
                    <p>Part of</p>
                    <a href="http://www.iprsgroup.com/" target="_blank" rel="noreferrer" className="footer__logo replace">IPRS Group</a>
                </div>
                <div className="footer__right">
                    <p><a href="https://www.iprshealth.com/cookie-policy/" rel="noreferrer" target="_blank">Privacy &amp; Cookies</a></p>
                    <br /><br /><br />
                    <p><small>&copy; 2019 IPRS Health Limited, Suffolk House, Bramford Road, Little Blakenham, Suffolk IP8 4JU</small></p>
                    <p><small>Website design: <a href="http://www.nakedmarketing.co.uk/" rel="noreferrer" target="_blank">Naked Marketing</a></small></p>
                </div>
            </div>
        </div>
    </footer>
  )
}

export default Footer